// Heatmap de remplissage moyen (PIL-01 lot 8) : fonctions pures, testables en node.

/** Heatmap de remplissage moyen (lot 8) : poids = taux de remplissage moyen du PAV sur la plage, `null` sans collecte. */
export function poidsRemplissage(etat) {
    return typeof etat.tauxRemplissage === 'number' ? etat.tauxRemplissage : null;
}

export const SEUIL_DENSITE = 0.05;

/**
 * Moyenne locale pondérée (heatmap de remplissage, sans biais de densité) : sur le même noyau gaussien k,
 * `N = Σ w_i·k_i` et `D = Σ k_i` ; la valeur d'un pixel est `N / D` là où `D > seuil`, sinon `null`.
 * `points` : [{x, y, w}] en pixels de grille ; `grille` : {largeur, hauteur, rayon (px, support du noyau, sigma = rayon / 2,5), seuil}.
 * @returns {{N: Float32Array, D: Float32Array, largeur, hauteur, seuil, valeur(x, y): number|null}}
 */
export function moyenneLocale(points, {largeur, hauteur, rayon, seuil = SEUIL_DENSITE}) {
    const N = new Float32Array(largeur * hauteur);
    const D = new Float32Array(largeur * hauteur);
    const sigma = rayon / 2.5;
    const coef = -1 / (2 * sigma * sigma);
    const r2 = rayon * rayon;
    for (const p of points) {
        const x0 = Math.max(0, Math.ceil(p.x - rayon));
        const x1 = Math.min(largeur - 1, Math.floor(p.x + rayon));
        const y0 = Math.max(0, Math.ceil(p.y - rayon));
        const y1 = Math.min(hauteur - 1, Math.floor(p.y + rayon));
        for (let y = y0; y <= y1; y++) {
            const dy = y - p.y;
            const ligne = y * largeur;
            for (let x = x0; x <= x1; x++) {
                const dx = x - p.x;
                const d2 = dx * dx + dy * dy;
                if (d2 > r2) continue;
                const k = Math.exp(d2 * coef);
                N[ligne + x] += p.w * k;
                D[ligne + x] += k;
            }
        }
    }
    return {N, D, largeur, hauteur, seuil, valeur: (x, y) => { const i = y * largeur + x; return D[i] > seuil ? N[i] / D[i] : null; }};
}
